module.exports = __webpack_public_path__ + "img/ods-logo-rueda.230d2288.png";